export { MemberTimers } from './member/membertimers';
export { MemberLesson } from './member/memberlesson';
export { KeepAlive } from './member/keepalive';
export { AutoLogin } from './member/autologin';
export { CourseInactivityRedirect } from './member/courseinactivityredirect';

// related to biometric logins
export { webAuthnDetectSupport } from './webauthn/utility';
export { webAuthnRegister, webAuthnSave, webAuthnLogin } from './webauthn/register';

//export { initCourseActivity } from './member/courseactivity';
